var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCellSignalSlash = function SvgIconCellSignalSlash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.75 13.847V4.664L13.936 8.48a1 1 0 1 1-1.415-1.414l4.236-4.236a1.75 1.75 0 0 1 2.993 1.229v9.789a1 1 0 1 1-2 0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.827 3.01a1 1 0 0 1 1.413.067l6.004 6.605a1 1 0 0 1 .135.148l8.86 9.747a.997.997 0 0 1-.066 1.413 1 1 0 0 1-.673.26H2.558a1.75 1.75 0 0 1-1.229-2.994l7.861-7.86-5.43-5.973a1 1 0 0 1 .067-1.413m-.663 16.24 7.373-7.373 6.702 7.373z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconCellSignalSlash;